import service from '@/utils/request'
import { getToken } from '@/utils/auth'

export function login (data) {
  return service({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo () {
  const token = getToken()
  if(!token) {
    return true
  }
  const ret = service({
    url: '/auth/check',
    method: 'get'
  })
  ret.catch(() => console.error('User not logged'))
  return ret
}

export function logout () {
  return service({
    url: '/auth/logout',
    method: 'delete'
  })
}

export function resetPass (data) {
  return service({
    url: '/auth/resetPassword',
    method: 'put',
    data
  })
}

export function confirmResetPass (data) {
  return service({
    url: '/auth/confirmResetPassword',
    method: 'put',
    data
  })
}

export function changePass (data) {
  return service({
    url: '/auth/changePassword',
    method: 'put',
    data
  })
}

export function getConfig() {
  const ret = service({
    url: '/config',
    method: 'get'
  })
  return ret  
}

export function checkRestorePassToken(token, email) {
  const ret = service({
    //ISSUE 174 GORRETA 20250415
    url: '/check_restore_pass_token?restore_pass_token=' + encodeURIComponent(token) + '&email=' + encodeURIComponent(email),
    //ISSUE 174 GORRETA 20250415
    method: 'get'
  })
  return ret  
}